<template>
  <div class="flex" :class="wrapperClassArray">
    <slot
      name="autoWrapper"
      :classes="['flex-auto']"
      :styles="autoStyleArray"
      style="background-color: green;"
      class="abc"
    >
      <div
        v-if="$slots.auto"
        class="flex-auto"
        :class="autoClassArray"
        :style="autoStyleArray"
      >
        <slot name="auto" />
      </div>
    </slot>
    <slot name="fillWrapper" :classes="['flex-fill']">
      <div class="flex-fill" :class="fillClassArray">
        <slot />
      </div>
    </slot>
  </div>
</template>
<script>
const splitClasses = (classes) => {
  if (!classes) {
    return [];
  }
  if (Array.isArray(classes)) {
    return classes;
  }
  return classes.split(/ +/gim).filter((it) => it);
};
export default {
  name: "layout-flex",
  props: {
    direction: {
      type: String,
      default: "column",
      validator(value) {
        return ["column", "row"].includes(value);
      },
    },
    vAlign: {
      type: String,
      validator(value) {
        return ["top", "center", "bottom"].includes(value);
      },
    },
    hAlign: {
      type: String,
      validator(value) {
        return ["left", "center", "right"].includes(value);
      },
    },
    limit: {
      type: String,
    },
    wrapperClasses: {
      type: [String, Array],
    },
    autoClasses: {
      type: [String, Array],
    },
    fillClasses: {
      type: [String, Array],
    },
    layout: {
      type: String,
      default: "block",
      validator(value) {
        // 这个值必须匹配下列字符串中的一个
        return ["flex", "block"].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    autoClassArray() {
      const { labelClasses } = this.$props;
      return splitClasses(labelClasses);
    },
    wrapperClassArray() {
      const { wrapperClasses, direction, vAlign, hAlign } = this.$props;
      const array = splitClasses(wrapperClasses);
      if (direction) {
        array.push(`flex-${direction}`);
      }
      if (vAlign) {
        array.push(`v-${vAlign}`);
      }
      if (hAlign) {
        array.push(`h-${hAlign}`);
      }
      return array;
    },
    fillClassArray() {
      const { contentClasses } = this.$props;
      return splitClasses(contentClasses);
    },
    autoStyleArray() {
      const { limit } = this.$props;
      if (limit) {
        return { flexBasis: limit };
      }
      return {};
    },
  },
  methods: {
    checkFlexItem(node) {
      if (!node) {
        return false;
      }
      if (!node.componentOptions) {
        return false;
      }
      return node.componentOptions.tag === "flex-item";
    },
  },
};
</script>
<style scoped />
